import React from 'react'
import { Modal,Button } from 'react-bootstrap';
import Close from '../../assets/images/close.png'

const CustomModal = (props,{id}) => {
  return (
    <div>
      <Modal id ={id}
       {...props} 
       size="md"
       aria-labelledby="contained-modal-title-vcenter"
       backdrop="static"
       centered>
                <Modal.Header className='modalHeader border-0'>
                    <Modal.Title id="contained-modal-title-vcenter">
                      {props.title}
                    </Modal.Title> 
                    {/* <button type="button" className="close" onClick={props.onHide} aria-label="Close">
                       <img src={Close} alt='Close' />
                    </button> */}
                </Modal.Header>
                <Modal.Body className='py-0 pt-0'>
                    {props.content}
                </Modal.Body>
                <Modal.Footer className='border-0 gap-2'>
                   {props.footer}
                </Modal.Footer>
      </Modal> 
    </div>
  )
}

export default CustomModal;